import React from 'react';
import classNames from 'classnames';
import { hasWebPSupport } from '@ratedpeople/utils';
import InputContainer from '@ratedpeople/input-container';
import Select from '@ratedpeople/select';
import Button from '@ratedpeople/button';
import Label from '@ratedpeople/label';
import InputError from '@ratedpeople/input-error';
import ContentTexts from '../ContentTexts';
import style from './DefaultLayout.module.scss';

var DefaultLayout = function DefaultLayout(props) {
  var _classNames;

  return /*#__PURE__*/React.createElement("div", {
    className: classNames(style["theme--" + props.theme], style["input-theme--" + props.inputTheme], props.className)
  }, Boolean(props.backgroundImages.length) && props.backgroundImages.map(function (item) {
    var sizeImage = item.sizeImage,
        source = item.source,
        sourceFallback = item.sourceFallback;
    return /*#__PURE__*/React.createElement("div", {
      key: sizeImage,
      className: classNames(style["display-" + sizeImage], style['banner-image']),
      style: {
        backgroundImage: "url(" + (hasWebPSupport() ? source : sourceFallback) + ")"
      }
    });
  }), /*#__PURE__*/React.createElement("div", {
    style: props.inlineStyleJobFormArea,
    className: classNames((_classNames = {}, _classNames["" + style['themed-jobform-area']] = props.theme === 'hero', _classNames))
  }, props.contentTexts.texts && props.contentTexts.texts.length ? /*#__PURE__*/React.createElement(ContentTexts, {
    theme: props.theme,
    contentTexts: props.contentTexts
  }) : /*#__PURE__*/React.createElement("p", {
    className: style['title']
  }, "Post your job for free, get up to 3 quotes"), /*#__PURE__*/React.createElement("div", {
    className: classNames(style['jobform-entry_inputs'], style["jobform-entry_inputs--" + props.flexDirection])
  }, /*#__PURE__*/React.createElement(InputContainer, {
    flushTop: true,
    className: style['jobform-entry_input-container']
  }, /*#__PURE__*/React.createElement(Label, {
    htmlFor: "trade-" + props.instance,
    fontSize: props.inputTheme === 'material' ? 'large' : 'default'
  }, "What type of tradesperson do you need?"), /*#__PURE__*/React.createElement(Select, {
    theme: props.inputTheme,
    isError: props.tradeError,
    required: true,
    name: "trade",
    options: props.tradeOptions,
    onChange: props.onTradeChange,
    value: props.trade,
    id: "trade-" + props.instance,
    placeholder: "Please select",
    hasOptionGroups: props.hasPopularTrades
  }), props.tradeError && /*#__PURE__*/React.createElement(InputError, {
    theme: props.inputErrorTheme
  }, "Select a trade")), /*#__PURE__*/React.createElement(InputContainer, {
    flushTop: true,
    className: style['jobform-entry_input-container']
  }, /*#__PURE__*/React.createElement(Label, {
    htmlFor: "skill-" + props.instance,
    fontSize: props.inputTheme === 'material' ? 'large' : 'default'
  }, "What type of job is it?"), /*#__PURE__*/React.createElement(Select, {
    theme: props.inputTheme,
    isError: props.skillError,
    required: true,
    name: "skill",
    options: props.skillsOptions,
    onChange: props.onChange,
    value: props.skill,
    id: "skill-" + props.instance,
    placeholder: "Please select"
  }), props.skillError && /*#__PURE__*/React.createElement(InputError, {
    theme: props.inputErrorTheme
  }, "Select a job type")), /*#__PURE__*/React.createElement(InputContainer, {
    flushTop: true,
    className: classNames(style['jobform-entry_input-container'], style['jobform-entry_button-container'], style["jobform-entry_inputs--" + props.flexJustify])
  }, props.showCancelButton && /*#__PURE__*/React.createElement(Button, {
    theme: "secondary",
    className: style['jobform-entry_button-cancel'],
    onClick: props.cancelCallback
  }, "Cancel"), /*#__PURE__*/React.createElement(Button, {
    type: "submit",
    theme: "primary",
    fill: props.buttonFill,
    className: style['jobform-entry_button']
  }, props.buttonText)))));
};

export default DefaultLayout;